import { PDFDocument } from "pdf-lib";

const fetchPDF = async (pdfPath, token = null) => {
  try {
    const headers = {};
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/upload/files/${pdfPath}`, {
      method: 'GET',
      headers: headers,
      credentials: 'include'
    });
    
    if (!response.ok) throw new Error("Failed to fetch PDF");

    return await response.blob(); // Return Blob for conversion
  } catch (error) {
    console.error("Error fetching file:", error);
    return null;
  }
};

const fileToArrayBuffer = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
};

const mergePdfs = async (pdfPaths, token = null) => {
  try {
    const mergedPdf = await PDFDocument.create();

    for (const path of pdfPaths) {
      const blob = await fetchPDF(path, token);
      if (!blob) continue;

      const arrayBuffer = await fileToArrayBuffer(blob);
      const pdfDoc = await PDFDocument.load(arrayBuffer);
      const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
      copiedPages.forEach((page) => mergedPdf.addPage(page));
    }

    const mergedPdfBytes = await mergedPdf.save();
    return new Blob([mergedPdfBytes], { type: "application/pdf" });
  } catch (error) {
    console.error("Error merging PDFs:", error);
    return null;
  }
};

// Exported functions to be used in another component
export const handleViewFinalPDF = async (pdfPaths, token = null) => {
  const mergedBlob = await mergePdfs(pdfPaths, token);
  if (!mergedBlob) return;

  const url = URL.createObjectURL(mergedBlob);
  window.open(url, "_blank"); // Open merged PDF in a new tab
};

export const handlePrintFinalPDF = async (pdfPaths, token = null) => {
  const mergedBlob = await mergePdfs(pdfPaths, token);
  if (!mergedBlob) return;

  const url = URL.createObjectURL(mergedBlob);
  const newWindow = window.open(url);
  if (newWindow) {
    newWindow.onload = () => newWindow.print();
  } else {
    console.error("Popup blocked! Enable popups to print the document.");
  }
};
